/* gives access to darkMode value (boolean) and listen to changes */

import { mapActions } from 'pinia';
import useUserOptionsStore from '@/stores/user-options';

export default {
  computed: {
    darkMode: {
      get() {
        return this.$vuetify.theme.global.current.dark;
      },
      set(newVal) {
        this.$vuetify.theme.change(newVal ? 'dark' : 'light');
        window.localStorageWrapper.setItem('theme', this.$vuetify.theme.global.name); // save in localStorage to avoid flickering before loading user options
        this.saveUserOption({ key: 'appearance-theme', value: this.$vuetify.theme.global.name });
      },
    },
  },
  methods: {
    ...mapActions(useUserOptionsStore, ['saveUserOption']),
  },
};
